import { Stack } from '@christiankaindl/lyts'
import { type CSSProperties, type Ref } from 'react'
import * as styles from './Placeholder.css'

interface PlaceholderProps {
  /**
   * - `text`: `numLines` lines, each `width` (default: varying) × `height` (default 1.5em)
   * - `image` / `card`: one block of `width` × `height` (`card` defaults to a 12px radius)
   */
  type?: 'text' | 'card' | 'image'
  aspectRatio?: string
  height?: CSSProperties['height']
  width?: CSSProperties['width']
  radius?: CSSProperties['borderRadius']
  style?: CSSProperties
  numLines?: number
  ref?: Ref<HTMLDivElement>
}
export default function Placeholder({
  type = 'text',
  aspectRatio,
  style = {},
  numLines = 1,
  width,
  height,
  radius,
  ref,
}: PlaceholderProps) {
  if (type === 'text') {
    const widths = Array.from(
      { length: numLines },
      (_, index) => 7 + (index % 3),
    )
    return (
      <Stack gap={0.5} ref={ref} aria-hidden>
        {widths.map((lineWidth, index) => (
          <div
            className={styles.root}
            key={index}
            style={{
              height: height ?? '1.5em',
              width: width ?? `${lineWidth}em`,
              maxWidth: '100%',
              borderRadius: radius,
            }}
          />
        ))}
      </Stack>
    )
  }

  return (
    <div
      aria-hidden
      className={styles.root}
      style={{
        ...style,
        width,
        height,
        aspectRatio,
        borderRadius: radius ?? (type === 'card' ? 12 : undefined),
      }}
      ref={ref}
    />
  )
}
